<footer class="app-footer">
  <div class="footer-container row">
    <div class="wazari col-md-12">
      <div>&#64;MeilleurtauxSanté {{ Year }}</div>
    </div>
  </div>
</footer>
